const Table = () => import('@/../../coreui/components/ServerTable')

export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null || allowed.includes('Facilities'))  {
  return [
    {
      path: '/SetRooms',
      name: 'SetRooms',
      component: Table,
      props: {
        schema: 'sch_set_rooms', 
        table: 'set_rooms'
      } 
    },
    {
      path: '/SetStrain',
      name: 'SetStrain',
      component: Table,
      props: {
        schema: 'sch_set_strain', 
        table: 'set_strain'
      } 
    },
  ]}
  return routes
}
